<template>
  <paginate
    v-if="maxPages > 1"
    v-model="currentPage"
    :page-count="maxPages"
    :click-handler="update"
    :prev-text="'Previous'"
    :next-text="'Next'"
    prev-class="page-item"
    next-class="page-item"
    container-class="pagination"
    page-class="page-item"
    page-link-class="page-link"
    prev-link-class="page-link"
    next-link-class="page-link"
  >
  </paginate>
</template>

<script>
import Paginate from 'vuejs-paginate'
export default {
  name: 'ui-pagination',
  components: { Paginate },
  props: {
    maxPages: Number,
    value: Number
  },
  data() {
    return {
      currentPage: this.value
    }
  },
  methods: {
    update() {
      this.$emit('input', this.currentPage)
    }
  },
  watch: {
    value() {
      this.currentPage = this.value
    }
  }
}
</script>
